import { useState } from 'react';

import { T_PredictionWinnerModalType } from '@/ts/types/T_PredictionWinnerModalType';

export type T_SelectedParticipation = {
  predictionEvent: {
    name: string;
    tokenSymbol: string;
    shortName?: string;
    startTime?: string;
    endTime: string;
    resolutionTime?: string;
    realPriceDecimal: string | null;
    tokenIcon?: {
      url: string;
      alt: string;
    };
  };
  hasWon?: boolean;
  hasClaimed?: boolean;
  lostAmountDecimal?: string | null;
  claimData?: {
    predictionId: string;
    rewardAmount: string;
    predictedPrice: number;
    submittedAt: number;
    merkleProofs: string[];
  };
};

export function useSectionState() {
  const [isClaiming, setIsClaiming] = useState(false);
  const [isModalClaiming, setIsModalClaiming] = useState(false);
  const [claimingParticipationId, setClaimingParticipationId] = useState<
    string | null
  >(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [defaultTab, setDefaultTab] = useState<'prime' | 'flash'>('prime');
  const [modalType, setModalType] =
    useState<T_PredictionWinnerModalType>('winners');
  const [modalVariant, setModalVariant] = useState<
    'BTC' | 'ETH' | 'SOL' | 'XRP'
  >('BTC');
  const [predictionAddress, setPredictionAddress] = useState<string | null>(
    null
  );
  const [predictionId, setPredictionId] = useState<string | null>(null);
  const [selectedParticipation, setSelectedParticipation] =
    useState<T_SelectedParticipation | null>(null);

  return {
    isClaiming,
    setIsClaiming,
    isModalClaiming,
    setIsModalClaiming,
    claimingParticipationId,
    setClaimingParticipationId,
    isModalOpen,
    setIsModalOpen,
    defaultTab,
    setDefaultTab,
    modalType,
    setModalType,
    modalVariant,
    setModalVariant,
    predictionAddress,
    setPredictionAddress,
    predictionId,
    setPredictionId,
    selectedParticipation,
    setSelectedParticipation
  };
}
